export default "__VITE_ASSET__BrEWA0qe__"